import Vue from 'vue'
import ReportTable from "../components/ReportTable"

let vm={
    components:{ReportTable},
    data:()=>{
        return{
            width:null,
            input_is_show:true,
            tableColumn:[
                {title:'股票代码',field:"ticker" ,width:100},
                {title:'股票简称',field:"short_name" ,width:100},
                {title:'行业',field:"gics_name",width:200},
                {title:'发布日期',field:'publish_date' ,width:100,sortType:"date",sortable:true},
                {title:'标题',field:"title",},
                {title:'机构',field:"institution",width:100},
                {title:'研究员',field:"researcher_name",width:200},
                {title:'主题词',field:"subject_words",width:300,},
                {title:'创新性',field:"innovation_rate",width:100,sortType:"number",sortable:true},
                {title: "详情", slots: {default: 'num_default'},width:80},
            ],
        }
    },
}

Vue.component("topic-search", vm)
export default vm




// WEBPACK FOOTER //
// ./src/research_report/js/topic_search.js